<template>
    <div></div>
</template>

<script>
export default {
    name: "Promet"
}
</script>

<style scoped>

</style>